import { search } from "../../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);
const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/bff/rural-establishment`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function getCompanyRuralEstablishments({
  page = 1,
  perPage = 10,
  filter = {},
  relations = "",
  multipleFilterValue = "",
}) {
  const url = new URL(`${path}/list`);

  Object.entries(filter).forEach(([name, value]) =>
    url.searchParams.append(`filter[${name}]`, value)
  );

  url.searchParams.append("page", page);
  url.searchParams.append("perPage", perPage);
  if (relations) url.searchParams.append("relations", relations);
  if (multipleFilterValue)
    url.searchParams.append("multipleFilterValue", multipleFilterValue);

  return search(decodeURIComponent(url), "GET", headers);
}
